$('#loyalty-button').click(function (e) { 
  e.preventDefault();
  var emailValue = $('input[name="contact[email]"]').val();
  window.location.href = "https://bogartstore.no/a/loyalty?email=" + encodeURIComponent(emailValue);
});


if (window.location.href.indexOf("/loyalty") !== -1) {
var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');
        
        console.log('Email:', email);
        
        // You can use the email value as needed, for example:
        $("#email").val(email);
        // alert("Email: " + email); // Display an alert with the email value
    } else {
        console.log('Email parameter not found in the URL.');
    }
}


